/**
 * RESPONSIBILITY: draw where an event happens.
 *
 * An address and a link out, not a map. An embedded map is a third-party script and a
 * tracking cookie for something every visitor's phone already does better from a tapped
 * address.
 */
import { Html } from '@framework/react';
import { THEME } from '@app/sections';
import { Band } from './Band';
import type { BandProps } from './kind';
import { mapTarget } from '../../commons/map-link';

export function Location({ s }: BandProps) {
  if (!s.address && !s.mapHref) return null;

  return (
    <Band theme={THEME.Location} heading={s.heading}>
      {s.address ? <address className="ev-address">{s.address}</address> : null}
      {s.bodyHtml ? <Html className="md-body ev-prose">{s.bodyHtml}</Html> : null}
      {s.mapHref
        ? <p className="ev-btns"><a className="btn btn-ghost" href={s.mapHref} {...mapTarget(s.mapHref)}>{s.mapLabel}</a></p>
        : null}
    </Band>
  );
}
